import get from 'lodash/get'
import isNull from 'lodash/isNull'

const formDataToRequestParams = <P>(params: P, upload = false, singleFile = false): FormData => {
    const requestParams = new FormData()

    if (upload) {
        // @ts-ignore
        requestParams.set(singleFile ? 'file' : 'files[]', params.file)
    } else {
        Object.keys(params).forEach((name) => {
            const value = get(params, name)
            requestParams.set(name, isNull(value) ? value : value.toString())
        })
    }
    // @ts-ignore
    if (params.location_id) requestParams.set('location_id', params.location_id)

    return requestParams
}

const formDataToOrderRequest = <P extends Record<string, any>>(params: P): FormData => {
    const requestParams = new FormData()

    Object.keys(params).forEach((name) => {
        const value = get(params, name)

        if (Array.isArray(value)) {
            // @ts-ignore
            value.forEach((item) => {
                if (item !== null && item !== undefined) {
                    requestParams.append(`${name}[]`, item.toString())
                }
            })
        } else if (value !== null && value !== undefined) {
            requestParams.set(name, value.toString())
        }
    })

    return requestParams
}

const uploadContributionFormDataToRequestParams = <P>(params: P, upload = false): FormData => {
    const requestParams = new FormData()

    if (upload) {
        // @ts-ignore
        requestParams.set('files[]', params.file)
    } else {
        Object.keys(params).forEach((name) => {
            const value = get(params, name)
            console.log(value)
            if (Array.isArray(value)) {
                requestParams.set('comments', JSON.stringify(value))
            } else {
                requestParams.set(name, isNull(value) ? value : value.toString())
            }
        })
    }

    return requestParams
}

export { formDataToRequestParams, formDataToOrderRequest, uploadContributionFormDataToRequestParams }
